module.exports = __webpack_public_path__ + "static/media/Webshop.25ee6627.png";